module.exports = __webpack_public_path__ + "static/media/salade.a0626471.png";